import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import globalContext from "../contexts/global";
import { removeUser, updateAccessToken } from "../contexts/UserContext/actions";

const refreshTokenString = '/token/refresh/'
let refreshPromise: Promise<string> | null = null

export const apiClient = (): AxiosInstance => {
  const { userContext } = globalContext.call
  const { user, dispatch } = userContext
  const { access_token, language } = user

  const headers: Record<string, string | boolean> = {
    Authorization: access_token ? `Bearer ${access_token}` : 'no',
    'Accept-Language': language
  }

  if (access_token) headers['Access-Control-Allow-Credentials'] = true

  const params: AxiosRequestConfig = {
    baseURL: `${import.meta.env.VITE_API_URL}/api`,
    headers,
    withCredentials: false,
  }

  const ac = axios.create(params)
  ac.interceptors.response.use((response) => response, async (error) => {
    const originalRequest = error.config
    if (error?.response?.status !== 401) return Promise.reject(error)

    // The refresh request itself was rejected, nothing left to retry with
    if (originalRequest.url === refreshTokenString) {
      dispatch(removeUser())
      return Promise.reject(error)
    }

    if (originalRequest._retry) return Promise.reject(error)
    originalRequest._retry = true

    const { refresh_token } = user
    if (!refresh_token) {
      dispatch(removeUser())
      return Promise.reject(error)
    }

    try {
      if (!refreshPromise) {
        refreshPromise = ac.post(refreshTokenString, { refresh: refresh_token })
          .then((resp) => {
            dispatch(updateAccessToken(resp.data.access))
            return resp.data.access
          })
          .finally(() => {
            refreshPromise = null
          })
      }

      const newAccessToken = await refreshPromise
      originalRequest.headers.Authorization = `Bearer ${newAccessToken}`
      return axios(originalRequest)
    } catch (refreshError) {
      dispatch(removeUser())
      return Promise.reject(error)
    }
  })

  return ac
}
